<div class="loading-indicator-wrapper" *ngIf="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>